import { Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { UserInfo, UserQuota } from "types";

import { SET_USER_INFO, SET_USER_QUOTA } from "./constants";
import { State } from "redux/store";

import { axiosGet, composeApiURL } from "helpers/utility/axiosHelpers";
import { initPendo } from "helpers/utility/pendo";

import { User } from "types";
import axios from "helpers/axiosInstance";
import { trackUserEmail } from "helpers/utility/amplitude";

const HOST_URL = process.env.REACT_APP_API_ENDPOINT!;

export const setUserInfo = (data: UserInfo) => {
  return { type: SET_USER_INFO, data };
};

export const setUserQuota = (data: UserQuota | null) => {
  return { type: SET_USER_QUOTA, data };
};

export const fetchUserInfo = (
  user: User,
): ThunkAction<void, State, unknown, any> => {
  return async (dispatch: Dispatch) => {
    try {
      const url = composeApiURL(process.env.REACT_APP_API_ENDPOINT!, `/user`);
      let response = await axiosGet(url);
      let userInfo: UserInfo = {
        userAvatar: response.data.avatar_uri,
        isInternalUser: response.data.is_internal_user,
        email: response.data.email,
        userId: response.data.user_id,
        identityProvider: response.data.identity_provider,
        name: response.data.name,
        username: response.data.username,
      };
      if (response.data.email) {
        trackUserEmail(response.data.email);
      }
      dispatch(setUserInfo(userInfo));
      initPendo(user, userInfo.email);
    } catch (error) {
      console.log(error);
    }
  };
};

export const checkUserQuota = (): ThunkAction<void, State, unknown, any> => {
  return async (dispatch: Dispatch) => {
    try {
      const url = composeApiURL(HOST_URL, `/usage_report`);
      const { data: responseData } = await axios.get(url);

      if (responseData) {
        const quota: UserQuota = {
          accountType: responseData.account,
          totalQuota: responseData.image_quota,
          usedQuota: responseData.image_usage,
          availableQuota: responseData.remaining_quota,
          email: responseData.email,
        };

        dispatch(setUserQuota(quota));
      } else {
        dispatch(setUserQuota(null));
      }
    } catch (error: any) {
      console.log(error);
    }
  };
};
